import React, { PropTypes, Component } from 'react';

class Testimonials extends Component {
    render () {
        return (
            <div className="section testimonials">
              <div className="testimonials-header">
                <h2>Testimonials</h2>
                <h3>What our clients say</h3>
              </div>
              <div className="testimonials-body">
                <ul className="testimonials-items">
                  <li className="testimonial">
                    <p className="quote">
                      So helpful
                    </p>
                    <div className="bio">
                      <img alt="Name avatar" className="avatar" src="" />
                      <span className="name">
                        Name
                      </span>
                      <span className="title">
                        Client
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
        );
    }
}

export default Testimonials;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Testimonials.js
 **/